import React from 'react'
import { Row, Col } from 'reactstrap'

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="6">
            <div className="copyright text-center text-xl-left text-muted">
              © 2020 Terrarrium
            </div>
          </Col>

          <Col xl="6" />
        </Row>
      </footer>
    )
  }
}

export default Footer
